import { Link } from 'react-router-dom';
import BasicTable from './BasicTable';

const SupportTicketTable = ({ data }) => {

    const columns = [
        {
            header: "ID",
            accessorKey: "id",
            cell: ({ getValue }) => (
                <span className="fw-semibold">{getValue()}</span>
            ),
        },
        {
            header: "Name",
            accessorKey: "name",
            enableSorting: false,
        },
        {
            header: "Subject",
            accessorKey: "subject",
        },
        {
            header: "Ticket Type",
            accessorKey: "ticketType",
        },
        {
            header: "Priority",
            accessorKey: "priority",
        },
        {
            header: "Status",
            accessorKey: "status",
        },
        {
            header: "Entry Date",
            accessorKey: "entryDate",
        },
        {
            header: "Actions",
            accessorKey: "actions",
            cell: ({ row }) => (
                <div className="d-flex justify-content-center gap-2">
                    <Link to={`/suppot-ticket/${row.original.id}`} className="text-primary fs-5 cursor-pointer">
                        <i className="bx bxs-show"></i>
                    </Link>
                </div>

            ),
            enableSorting: false,
        },
    ];

    return (
        <>

            <BasicTable
                columns={columns}
                data={data}
                customPageSize={10}
            />

        </>
    );
};

export default SupportTicketTable;